import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';

import {
  ActivitySubscriptionEvent,
  ActivitySubscriptions,
  ActivitySubscriptionType,
  ActivitySubscriptionUpdateData,
} from '@recruitee/http/types';
import { IconComponent, RtStatefulComponent, SpinnerComponent } from '@recruitee/user-interface';

type State = {
  showSpinner: boolean;
  isClickable: boolean;
  isActive: boolean;
};

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[rt-activity-subscriptions-table-item]',
  templateUrl: './activity-subscriptions-table-item.component.html',
  styleUrls: ['./activity-subscriptions-table-item.component.less'],
  host: {
    '[class.active]': 'state.isActive',
    '[class.clickable]': 'state.isClickable && !state.showSpinner',
    '(click)': 'change()',
  },
  standalone: true,
  imports: [SpinnerComponent, IconComponent],
})
export class ActivitySubscriptionsTableItemComponent extends RtStatefulComponent<State> {
  @Input() public eventsGroup: ActivitySubscriptionEvent[];
  @Input() public type: Exclude<ActivitySubscriptionType, 'slack'>;
  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Output() public changeEvents: EventEmitter<ActivitySubscriptionUpdateData> = new EventEmitter();

  constructor(protected cdRef: ChangeDetectorRef) {
    super(cdRef);
    this.createState({
      showSpinner: false,
      isClickable: false,
      isActive: false,
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.activitySubscriptions) {
      const currentValue = changes.activitySubscriptions.currentValue;
      const clickable = currentValue !== null;
      const active = clickable && this.getValue(currentValue);
      this.setState({
        showSpinner: this.state.isActive !== active ? false : this.state.showSpinner,
        isClickable: clickable,
        isActive: active,
      });
    }
  }

  public change(): void {
    this.setState({
      ...this.state,
      showSpinner: true,
    });
    this.changeEvents.emit({
      type: this.type,
      events: this.eventsGroup,
      value: !this.state.isActive,
    });
  }

  private getValue(activitySubscriptions: ActivitySubscriptions): boolean {
    const groupKey = this.eventsGroup[0];
    return (
      activitySubscriptions &&
      activitySubscriptions[groupKey] &&
      activitySubscriptions[groupKey][this.type]
    );
  }
}
